// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.actionsColumnPopover__Sdcnk {
  width: 210px !important;
  padding: 0 !important;
  background: var(--context-menu-surface) !important;
  text-align: left !important;
  opacity: 1 !important;
  border-radius: 0;
  box-shadow: var(--modal-box-shadow);
}

.actionsColumnPopoverItem__FeJ8y {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  text-transform: uppercase;
  color: var(--context-menu-text);
  font-size: 10px;
  border: 1px solid var(--context-menu-stroke);
  border-bottom: unset;
}
.actionsColumnPopoverItem__FeJ8y:hover {
  font-weight: 500;
  background-color: inherit;
}
.actionsColumnPopoverItem__FeJ8y:last-child {
  border-bottom: 1px solid var(--context-menu-stroke);
}
.actionsColumnPopoverItem__FeJ8y svg {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}
.actionsColumnPopoverItem__FeJ8y .downloadIcon__XlMNw {
  width: 18px;
  height: 18px;
  margin-right: 6px;
}
.actionsColumnPopoverItem__FeJ8y .downloadIcon__XlMNw path {
  fill: var(--buttons-surface);
}
.actionsColumnPopoverItem__FeJ8y .editIcon__sGgBi path {
  fill: var(--buttons-surface);
}
.actionsColumnPopoverItem__FeJ8y .editIcon__sGgBi path:last-child {
  fill: var(--tables-secondary-row-sub-title-surface);
}
.actionsColumnPopoverItem__FeJ8y .resendEmailIcon__hqjUU path {
  fill: var(--buttons-surface);
}
.actionsColumnPopoverItem__FeJ8y .resetIcon__vqhFC path {
  fill: var(--buttons-surface);
}
.actionsColumnPopoverItem__FeJ8y .deleteIcon__PtAc8 path {
  fill: var(--buttons-surface);
}
.actionsColumnPopoverItem__FeJ8y .deleteIcon__PtAc8 path:nth-child(4) {
  stroke: var(--buttons-surface);
}
.actionsColumnPopoverItem__FeJ8y .deleteIcon__PtAc8 path:nth-child(5) {
  fill: var(--tables-secondary-row-sub-title-surface);
}
.actionsColumnPopoverItem__FeJ8y .deleteIcon__PtAc8 path:last-child {
  stroke: unset;
  fill: unset;
}
.actionsColumnPopoverItem__FeJ8y .resendIcon__SWYoD path {
  fill: var(--buttons-surface);
}
.actionsColumnPopoverItem__FeJ8y .unblockIcon__vBZwQ path {
  stroke: var(--buttons-surface);
}

.unblockExtraText__JlaCa {
  text-align: left;
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/Users/components/ContextMenu/style.module.scss"],"names":[],"mappings":"AA0EA;EAEE,uBAAA;EACA,qBAAA;EACA,kDAAA;EACA,2BAAA;EACA,qBAAA;EACA,gBAAA;EACA,mCAAA;AA1EF;;AA6EA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EACA,+BAAA;EACA,eAAA;EACA,4CAAA;EACA,oBAAA;AA1EF;AA4EE;EACE,gBAAA;EACA,yBAAA;AA1EJ;AA6EE;EACE,mDAAA;AA3EJ;AA8EE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA5EJ;AA+EE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA7EJ;AA+EI;EACE,4BAAA;AA7EN;AAkFI;EACE,4BAAA;AAhFN;AAkFM;EACE,mDAAA;AAhFR;AAsFI;EACE,4BAAA;AApFN;AAyFI;EACE,4BAAA;AAvFN;AA4FI;EACE,4BAAA;AA1FN;AA4FM;EACE,8BAAA;AA1FR;AA4FM;EACE,mDAAA;AA1FR;AA4FM;EACE,aAAA;EACA,WAAA;AA1FR;AAgGI;EACE,4BAAA;AA9FN;AAmGI;EACE,8BAAA;AAjGN;;AAsGA;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAnGF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.actionsColumnPopover {\n  // importants below to overwrite react-tooltip styles\n  width: 210px !important;\n  padding: 0 !important;\n  background: var(--context-menu-surface) !important;\n  text-align: left !important;\n  opacity: 1 !important;\n  border-radius: 0;\n  box-shadow: var(--modal-box-shadow);\n}\n\n.actionsColumnPopoverItem {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 10px;\n  text-transform: uppercase;\n  color: var(--context-menu-text);\n  font-size: 10px;\n  border: 1px solid var(--context-menu-stroke);\n  border-bottom: unset;\n\n  &:hover {\n    font-weight: 500;\n    background-color: inherit;\n  }\n\n  &:last-child {\n    border-bottom: 1px solid var(--context-menu-stroke);\n  }\n\n  svg {\n    width: 20px;\n    height: 20px;\n    margin-right: 6px;\n  }\n\n  .downloadIcon {\n    width: 18px;\n    height: 18px;\n    margin-right: 6px;\n\n    path {\n      fill: var(--buttons-surface);\n    }\n  }\n\n  .editIcon {\n    path {\n      fill: var(--buttons-surface);\n\n      &:last-child {\n        fill: var(--tables-secondary-row-sub-title-surface);\n      }\n    }\n  }\n\n  .resendEmailIcon {\n    path {\n      fill: var(--buttons-surface);\n    }\n  }\n\n  .resetIcon {\n    path {\n      fill: var(--buttons-surface);\n    }\n  }\n\n  .deleteIcon {\n    path {\n      fill: var(--buttons-surface);\n\n      &:nth-child(4) {\n        stroke: var(--buttons-surface);\n      }\n      &:nth-child(5) {\n        fill: var(--tables-secondary-row-sub-title-surface);\n      }\n      &:last-child {\n        stroke: unset;\n        fill: unset;\n      }\n    }\n  }\n\n  .resendIcon {\n    path {\n      fill: var(--buttons-surface);\n    }\n  }\n\n  .unblockIcon {\n    path {\n      stroke: var(--buttons-surface);\n    }\n  }\n}\n\n.unblockExtraText {\n  text-align: left;\n  margin-top: 25px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionsColumnPopover": `actionsColumnPopover__Sdcnk`,
	"actionsColumnPopoverItem": `actionsColumnPopoverItem__FeJ8y`,
	"downloadIcon": `downloadIcon__XlMNw`,
	"editIcon": `editIcon__sGgBi`,
	"resendEmailIcon": `resendEmailIcon__hqjUU`,
	"resetIcon": `resetIcon__vqhFC`,
	"deleteIcon": `deleteIcon__PtAc8`,
	"resendIcon": `resendIcon__SWYoD`,
	"unblockIcon": `unblockIcon__vBZwQ`,
	"unblockExtraText": `unblockExtraText__JlaCa`
};
module.exports = ___CSS_LOADER_EXPORT___;
